import {
  ALL_OPTIONS,
  TICKET_SELECTOR_MAP_INFO_MODAL,
  TICKET_SELECTOR_TEXT_INFO_MODAL_MAP_VALUES,
} from '../constants/ticket-selector-info-modal-values';
import { InfoModalEvent, SelectorCategory } from '../types';
import {
  InfoModalInterface,
  MapModalInterface,
} from '@modules/components-common';

export const determineTicketSelectorTextModalData = (
  infoModalEvent?: InfoModalEvent
): InfoModalInterface | undefined => {
  if (!infoModalEvent) {
    return undefined;
  }

  const allOptions =
    TICKET_SELECTOR_TEXT_INFO_MODAL_MAP_VALUES[
      infoModalEvent.domain as SelectorCategory
    ];

  if (!allOptions) {
    return undefined;
  }

  if (!infoModalEvent.subdomain) {
    return allOptions[ALL_OPTIONS];
  }

  const selectedModalData = allOptions[infoModalEvent.subdomain];
  if (!selectedModalData || !selectedModalData.title) {
    return undefined;
  }
  return selectedModalData;
};

export const determineTicketSelectorMapModalData = (
  infoModalEvent?: InfoModalEvent
): MapModalInterface | undefined => {
  if (!infoModalEvent) {
    return undefined;
  }

  if (!infoModalEvent.subdomain) {
    return undefined;
  }

  return TICKET_SELECTOR_MAP_INFO_MODAL[infoModalEvent.subdomain];
};
